import appConfig from '@/constants/appConfig'
import { useAppStore } from '@/stores/app'
import { getAccessToken } from '@/api/idp'

export function getAuthHeaders(isContentTypeNotRequired?: boolean): Record<string, string> {
  const accessToken = getAccessToken()
  const appStore = useAppStore()

  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken || 'invalid_token'}`,
    'portal-id': appStore.getPortalId?.toString() || '',
    'trace-session-id': appStore.getTraceSessionId || '',
    'x-client-app': appConfig.CLIENT_APP,
    'langfuse-project-id': import.meta.env.VITE_APP_TRACKING_PROJECT_ID || '',
    Portal: import.meta.env.DEV ? 'be.stunnr.co' : window.location.hostname,
    'Client-Id': appConfig.STUNNR_BE_CLIENT_ID
  }

  if (!isContentTypeNotRequired) {
    headers['Content-Type'] = 'application/json'
  }

  return headers
}

export function getAuthBodyForEnhancements(): Record<string,string>{
  const accessToken = getAccessToken()
  return {
    "dx-user-auth": `Bearer ${accessToken || 'invalid_token'}`
  }
}
